module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serial"
  }, [_c('SimpleHeader', {
    attrs: {
      "productInfo": _vm.productInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inner flexcenter"
  }, [_c('div', {
    staticClass: "serial-controls flexcenter"
  }, [_c('h3', [_vm._v("シリアル番号を入力して利用開始")]), _vm._v(" "), _c('div', {
    staticClass: "serial-input flexcenter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.serial),
      expression: "serial",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "serial-text",
    attrs: {
      "type": "text",
      "placeholder": "シリアル番号",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.serial)
    },
    on: {
      "input": function($event) {
        return _vm.validate($event)
      },
      "compositionstart": function($event) {
        _vm.ignore = true
      },
      "compositionend": function($event) {
        return _vm.composition($event)
      },
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doActivate($event)
      },
      "change": function($event) {
        _vm.serial = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "enter",
    on: {
      "click": function($event) {
        return _vm.doActivate($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/icon/svg/ar_r_login.svg",
      "alt": "enter"
    }
  })])]), _vm._v(" "), (_vm.message) ? _c('p', {
    staticClass: "serial-error"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _vm._m(0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticClass: "serial-anchor",
    attrs: {
      "href": "http://www.sourcenext.com/permission/104/",
      "target": "_blank"
    }
  }, [_vm._v("\n          Rosetta Stone について\n        ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a414edc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-6a414edc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Serial.vue
// module id = 634
// module chunks = 1